import ButtonLarge from 'common/ButtonLarge';
import CreateText from 'common/CreateText';
import styled from 'styled-components';

const ContainerDiv = styled.div`
    background: ${(props) => props.theme.colorBackground};
    width: 100%;
    height: 100%;
    min-height: 400px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .button {
        padding: 0px 60px;
    }

    .text {
        margin: 22px 0px;
    }
`;

export default function EmptyProviderHome({ togglePopup }) {
    return (
        <ContainerDiv>
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                    <path
                        d="M17.8112 22C19.9214 22 21.4779 20.4435 21.4779 18.3334C21.4779 16.2232 19.9214 14.6667 17.8112 14.6667C15.701 14.6667 14.1445 16.2232 14.1445 18.3334C14.1445 20.4435 15.6992 22 17.8112 22Z"
                        fill="#C4C4C4"
                    />
                    <path d="M33.0003 16.5H25.667V20.1667H33.0003V16.5Z" fill="#C4C4C4" />
                    <path d="M33.0003 23.8334H27.5003V27.5H33.0003V23.8334Z" fill="#C4C4C4" />
                    <path
                        d="M17.8112 23.375C21.5493 23.375 24.622 26.8144 24.622 29.3334H11.0003C11.0003 26.8144 14.073 23.375 17.8112 23.375Z"
                        fill="#C4C4C4"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M36.667 7.33337H7.33366C5.31149 7.33337 3.66699 8.87521 3.66699 10.7709V33.2292C3.66699 35.1249 5.31149 36.6667 7.33366 36.6667H36.667C38.6892 36.6667 40.3337 35.1249 40.3337 33.2292V10.7709C40.3337 8.87521 38.6892 7.33337 36.667 7.33337ZM36.667 33L7.33366 32.9799V11L36.667 11.0202V33Z"
                        fill="#C4C4C4"
                    />
                </svg>
            </div>

            <CreateText className="text">
                Add all of your <br />
                service providers
            </CreateText>

            <div>
                <ButtonLarge onClick={togglePopup} className="button">
                    Add a Provider
                </ButtonLarge>
            </div>
        </ContainerDiv>
    );
}
